import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import Adapter from './Adapter';
import ObjectDefinitionsAdapterConfig from '../adapterConfigs/ObjectDefinitionsAdapterConfig';
export class CustomObjectDefinitionsAdapterConfig extends ObjectDefinitionsAdapterConfig {
  getCacheKey() {
    return 'CUSTOM_OBJECT_DEFINITIONS';
  }
  includeObject(objectDefinition) {
    const {
      metaType
    } = objectDefinition;
    return metaType === 'PORTAL_SPECIFIC';
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === DSAssetFamilies.CUSTOM_OBJECT_DEFINITION;
  }
}
export default Adapter.makeFromConfig(CustomObjectDefinitionsAdapterConfig);